import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'ut/IMG_20201017_150259-PANO.jpg' satisfies MediaPath
const a = 'ut/IMG_20201011_183011.jpg' satisfies MediaPath
const b = 'az/IMG_20201012_164106.jpg' satisfies MediaPath
const c = 'az/IMG_20201013_095610.jpg' satisfies MediaPath
const d = 'az/IMG_20201107_162722.jpg' satisfies MediaPath
const e = 'mx/IMG_20201129_140829.jpg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: '2020',
	name: '2020',
	excerpt: 'Closer to home',
	tags: ['photography'],
	cover,
	featured: true,
	order: 150,
}

export default function Year2020() {
	return (
		<>
			<p>A year in frames.</p>
			<Gallery
				items={[
					{ src: cover, alt: '2020 — panorama' },
					{ src: a, alt: '2020' },
					{ src: b, alt: '2020' },
					{ src: c, alt: '2020' },
					{ src: d, alt: '2020' },
					{ src: e, alt: '2020' },
				]}
			/>
		</>
	)
}
